import * as TYPES from './constants';
import {
  receiveUniqueMembershipCodeCheck,
  requestUniqueMembershipCodeCheck,
  uniqueMembershipCodeCheckError,
} from './actions';

import {Services} from 'core';

import {API} from 'config/superuser.config';

const initialState = {
  data: null,
  request: null,
  error: null,
};

const services = new Services();

export default (state = initialState, action) => {
  switch (action.type) {
    case TYPES.REQUEST_UNIQUE_MEMBERSHIP_CODE:
      return {
        ...state,
        request: true,
      };
    case TYPES.RECEIVE_UNIQUE_MEMBERSHIP_CODE:
      return {
        ...state,
        data: action.payload,
        request: false,
        error: false,
      };
    case TYPES.UNIQUE_MEMBERSHIP_CODE_ERROR:
      return {
        ...state,
        error: true,
        request: false,
      };
    default:
      return state;
  }
};

export const fetchUniqueMembershipCodeValidation = (code, callback) => (
  dispatch,
  getState
) => {
  const {
    auth: {access: {token = null} = {}},
  } = getState();
  dispatch(requestUniqueMembershipCodeCheck());
  let endpoint = `${API.administration.institution}?unique_member_code=${code}`;
  try {
    return services
      .fetchRecords(endpoint, token)
      .then(res => {
        dispatch(receiveUniqueMembershipCodeCheck(res));
        let agency = {};
        if (callback) {
          if (res?.license && Array.isArray(res.license) && res?.license[0]) {
            agency = res.license[0];
          }
          callback(agency);
        }
      })
      .catch(err => {
        console.log(err);
        dispatch(uniqueMembershipCodeCheckError(err));
        if (callback) callback(err);
      });
  } catch (err) {
    console.log(err);
    dispatch(uniqueMembershipCodeCheckError(err));
    if (callback) callback(err);
  }
};
